/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { ProcessingModalGlobal } from "../ProcessingModal";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class ProductLineEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            example: {
                name: 'Molecular'
            }
        }
    }

    async componentDidMount() {
        this.fillList('/api/productline/list', 'productLines');

        if (this.props.params.id) {
            await this.loadAsync(this.props.params.id);
        }
    }
    
    loadAsync = async (id) => {
        try {
            let j = await qreq.getAsync('/api/productline/get/' + id);
            if (j.errorCode === 0) {
                j.item.panels.forEach(i => i.selected = true);
                this.setState({ item: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch {
            this.unkownErrorCallback();
        }
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    submit = async (e) => {
        try {
            e?.preventDefault();
            var j = await qreq.postAsync('/api/productline/save', this.state.item);
            if (j.errorCode === 0) {
                this.success('Product line saved');
                this.goBack();
            }
            else
                this.alert('Error saving product line');
        }
        catch (e) {
            this.alert(e);
        }
    }

    suggest = async () => {
        ProcessingModalGlobal.show();
        try {
            let j = await qreq.taskAsync('/api/productline/suggest', this.state.item);
            if (j.errorCode === 0) {
                this.setState({ item: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback();
        }
        ProcessingModalGlobal.hide();
    }

    togglePanel = (e, item) => {
        let list = [...this.state.item.panels];
        let idx = list.findIndex(i => i === item);
        list[idx].selected = e.target.checked;
        this.setState({ item: {...this.state.item, panels: list} });
    }

    toggleAllPanels = (e) => {
        let list = [...this.state.item.panels];
        list.forEach(i => i.selected = e.target.checked);
        this.setState({ item: {...this.state.item, panels: list} });
    }

    isAllPanelsSelected = () => {
        return this.state.item.panels?.length > 0 && this.state.item.panels.every(i => i.selected);
    }

    render() {
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Product Line</h1>
                <Card title="Basic Information">
                    <div className="row">
                        <div className="col-md-12">
                            <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                            <button onClick={this.suggest} type="button" className="btn btn-success" disabled={!this.state.item.name}><Icon icon="faWandMagicSparkles" /> Suggest</button>
                        </div>
                    </div>
                </Card>
                {this.state.item.panels && <Card title="Panels">
                    <table className="table">
                        <thead>
                            <tr><th><input type="checkbox" checked={this.isAllPanelsSelected()} onChange={this.toggleAllPanels} /></th><th>Name</th><th>Code</th></tr>
                        </thead>
                        <tbody>
                            {this.state.item.panels?.map((i, idx) =>
                                <tr key={idx}><td><input type="checkbox" checked={i.selected} onChange={e => this.togglePanel(e, i)} /></td><td>{i.name}</td><td>{i.code}</td></tr>
                            )}
                        </tbody>
                    </table>
                </Card>}
                <Card title="Settings">
                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                            <small>Disable the product line completely from use.</small>
                        </div>
                    </div>
                </Card>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> Save</button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(ProductLineEdit);